export const StatusPedido = {
  Rascunho: 'Rascunho',
  Finalizado: 'Finalizado',
  Enviado: 'Enviado',
  AguardandoRetorno: 'A',
  RetornoProcessado: 'R',
  Pago: 'P',
  Bloqueado: 'B',
  Cancelado: 'Cancelado',
  SituacaoInicial: 'D',
  AguardandoPagamento: 'N',
  AguardandoFormaPagamento: 'AguardandoFormaPagamento',
  CanceladoNewcon: 'C',
  AguardandoAssinaturaContrato: 'Assinatura',
  AguardandoAssinaturaContratoAlocacao: 'AssinaturaAlocacao',
  FalhaAlocacao: 'FalhaAlocacao',
  AprovadoAnaliseCredito: 'AprovadoAnaliseCredito',
  ReprovadoAnaliseCredito: 'ReprovadoAnaliseCredito',
  AguardandoDecisaoAnaliseCredito: 'AguardandoDecisaoAnaliseCredito',
  PendenteAnaliseCredito: 'PendenteAnaliseCredito',
  AGENDADO_GERAR_PROPOSTA_CARRINHO: 'AgendadoGerarPropostaCarrinho',
  GERANDO_PROPOSTA_CARRINHO: 'GerandoPropostaCarrinho',
  ERRO_GERAR_PROPOSTA_CARRINHO: 'ErroGerarPropostaCarrinho'
}

export const StatusPagamentosPagos = [StatusPedido.Pago, StatusPedido.AguardandoAssinaturaContratoAlocacao]
export const StatusVendaNaoGerada = [StatusPedido.Rascunho, StatusPedido.AprovadoAnaliseCredito, StatusPedido.ReprovadoAnaliseCredito, StatusPedido.AguardandoDecisaoAnaliseCredito, StatusPedido.PendenteAnaliseCredito]
export const StatusVendaCanceladas = [StatusPedido.Cancelado, StatusPedido.Bloqueado, StatusPedido.CanceladoNewcon, StatusPedido.ReprovadoAnaliseCredito]

export const ListaAgrupamentosDeStatusPedido = {
  Rascunho: 'Rascunho',
  AguardandoEnvio: 'Aguardando envio',
  Pagamento: 'Pagamento',
  Finalizado: 'Finalizado',
  Bloqueado: 'Cancelado',
  Falha: 'Falha'
}
export const ListaAgrupamentosDeStatusPedidoPrioridade = {
  [ListaAgrupamentosDeStatusPedido.Bloqueado]: 1,
  [ListaAgrupamentosDeStatusPedido.Falha]: 2,
  [ListaAgrupamentosDeStatusPedido.Rascunho]: 3,
  [ListaAgrupamentosDeStatusPedido.AguardandoEnvio]: 4,
  [ListaAgrupamentosDeStatusPedido.Pagamento]: 5,
  [ListaAgrupamentosDeStatusPedido.Finalizado]: 6
}

export const StatusPedidoDesc = {
  [StatusPedido.Cancelado]: ListaAgrupamentosDeStatusPedido.Bloqueado,
  [StatusPedido.Bloqueado]: ListaAgrupamentosDeStatusPedido.Bloqueado,
  [StatusPedido.CanceladoNewcon]: ListaAgrupamentosDeStatusPedido.Bloqueado,
  [StatusPedido.ERRO_GERAR_PROPOSTA_CARRINHO]: ListaAgrupamentosDeStatusPedido.Falha,
  [StatusPedido.Rascunho]: ListaAgrupamentosDeStatusPedido.Rascunho,
  [StatusPedido.AprovadoAnaliseCredito]: ListaAgrupamentosDeStatusPedido.Rascunho,
  [StatusPedido.ReprovadoAnaliseCredito]: ListaAgrupamentosDeStatusPedido.Rascunho,
  [StatusPedido.AguardandoDecisaoAnaliseCredito]: ListaAgrupamentosDeStatusPedido.Rascunho,
  [StatusPedido.PendenteAnaliseCredito]: ListaAgrupamentosDeStatusPedido.Rascunho,
  [StatusPedido.Finalizado]: ListaAgrupamentosDeStatusPedido.AguardandoEnvio,
  [StatusPedido.SituacaoInicial]: ListaAgrupamentosDeStatusPedido.AguardandoEnvio,
  [StatusPedido.AguardandoAssinaturaContrato]: ListaAgrupamentosDeStatusPedido.AguardandoEnvio,
  [StatusPedido.AGENDADO_GERAR_PROPOSTA_CARRINHO]: ListaAgrupamentosDeStatusPedido.AguardandoEnvio,
  [StatusPedido.GERANDO_PROPOSTA_CARRINHO]: ListaAgrupamentosDeStatusPedido.AguardandoEnvio,
  [StatusPedido.Enviado]: ListaAgrupamentosDeStatusPedido.Pagamento,
  [StatusPedido.AguardandoFormaPagamento]: ListaAgrupamentosDeStatusPedido.Pagamento,
  [StatusPedido.AguardandoPagamento]: ListaAgrupamentosDeStatusPedido.Pagamento,
  [StatusPedido.AguardandoRetorno]: ListaAgrupamentosDeStatusPedido.Pagamento,
  AguardandoPagamentoCliente: ListaAgrupamentosDeStatusPedido.Pagamento,
  [StatusPedido.Pago]: ListaAgrupamentosDeStatusPedido.Finalizado,
  [StatusPedido.RetornoProcessado]: ListaAgrupamentosDeStatusPedido.Finalizado,
  [StatusPedido.AguardandoAssinaturaContratoAlocacao]: ListaAgrupamentosDeStatusPedido.Finalizado,
  [StatusPedido.FalhaAlocacao]: ListaAgrupamentosDeStatusPedido.Finalizado
}

export const StatusAnaliseCadastral = {
  Reprovado: 'Reprovado',
  Pendente: 'Pendente',
  EmAnalise: 'Em análise',
  Aprovado: 'Aprovado',
  PendenciaCadastral: 'Pendência'
}

export const StatusContrato = {
  ContratoCancelado: 'Cancelado',
  ContratoFalha: 'Falha',
  ContratoRejeitado: 'Rejeitado',
  ContratoPendente: 'Pendente',
  ContratoAssinado: 'Assinado',
  ContratoEmEspera: 'Em Espera',
  ContratoTodos: 'Todos'
}
export const ListaAgrupamentosDeStatusContrato = {
  Falha: 'Falha',
  EmEspera: 'Em Espera',
  Pendente: 'Pendente',
  Negado: 'Negado',
  Assinado: 'Assinado'
}

export const ListaAgrupamentosDeStatusContratoPrioridade = {
  [ListaAgrupamentosDeStatusContrato.Falha]: 1,
  [ListaAgrupamentosDeStatusContrato.Negado]: 2,
  [ListaAgrupamentosDeStatusContrato.EmEspera]: 3,
  [ListaAgrupamentosDeStatusContrato.Pendente]: 4,
  [ListaAgrupamentosDeStatusContrato.Assinado]: 5
}

export const agrupamentoStatusContratoCores = {
  [ListaAgrupamentosDeStatusContrato.Assinado]: '#1A984C',
  [ListaAgrupamentosDeStatusContrato.Pendente]: '#1E90FF',
  [ListaAgrupamentosDeStatusContrato.Falha]: '#DC222B',
  [ListaAgrupamentosDeStatusContrato.Negado]: '#f57d7d',
  [ListaAgrupamentosDeStatusContrato.EmEspera]: '#B8B8B8'
}
export const StatusContratoDesc = {
  [StatusContrato.ContratoFalha]: ListaAgrupamentosDeStatusContrato.Falha,
  [StatusContrato.ContratoCancelado]: ListaAgrupamentosDeStatusContrato.Negado,
  [StatusContrato.ContratoRejeitado]: ListaAgrupamentosDeStatusContrato.Negado,
  [StatusContrato.ContratoEmEspera]: ListaAgrupamentosDeStatusContrato.EmEspera,
  [StatusContrato.ContratoPendente]: ListaAgrupamentosDeStatusContrato.Pendente,
  [StatusContrato.ContratoAssinado]: ListaAgrupamentosDeStatusContrato.Assinado
}

export const abasDosFiltros = {
  Todas: { index: 0, value: '', text: 'Todas' },
  Rascunho: { index: 1, value: 'Rascunho', text: 'Rascunho' },
  EmProcesso: { index: 2, value: 'EmProcesso', text: 'Em Processo' },
  Cancelada: { index: 3, value: 'Cancelada', text: 'Canceladas' },
  Concluida: { index: 4, value: 'Concluida', text: 'Concluídas' }
}

export const StatusDocusign = {
  DocusignEnviado: 'enviado_docusign',
  DocusignAgendado: 'agendado_docusign',
  DocusignFalha: 'falha_docusign',
  DocusignTodos: 'todos_docusign'
}

export const StatusDocusignDesc = {
  [StatusDocusign.DocusignEnviado]: 'Enviado para Docusign',
  [StatusDocusign.DocusignAgendado]: 'Envio para docusign agendado',
  [StatusDocusign.DocusignFalha]: 'Erro no envio para docusing',
  [StatusDocusign.DocusignTodos]: 'Todos'

}

export const TipoNegociacaoFuro = {
  FuroEncerramento: 'furo_encerramento',
  FuroContemplacao: 'furo_contemplacao',
  Diluicao: 'diluicao'
}

export const TipoNegociacaoFuroDesc = {
  [TipoNegociacaoFuro.FuroContemplacao]: 'Furo na contemplação',
  [TipoNegociacaoFuro.FuroEncerramento]: 'Furo no encerramento',
  [TipoNegociacaoFuro.Diluicao]: 'Diluição'
}

export const PoliticamenteExposto = {
  NaoPoliticamenteExposto: 'nao_politicamente_exposto',
  AgentePublico: 'agente_publico',
  ParenteAgentePublico: 'parente_agente_publico',
  EstreitoColaborador: 'estreito_colaborador'
}

export const PoliticamenteExpostoDesc = {
  [PoliticamenteExposto.NaoPoliticamenteExposto]: 'Não é politicamente exposto',
  [PoliticamenteExposto.AgentePublico]: 'Agente público',
  [PoliticamenteExposto.ParenteAgentePublico]: 'Parente de agente público',
  [PoliticamenteExposto.EstreitoColaborador]: 'Estreito colaborador'
}

export const SituacaoGrupo = {
  Formacao: 'formacao',
  Andamento: 'andamento',
  Cancelado: 'cancelado'
}
export const SituacaoGrupoNewcon = {
  Formacao: 'F',
  Andamento: 'A'
}

export const TipoNegociacao = {
  Diluido: 'diluido',
  Furo: 'furo'
}

export const OpcoesFuro = {
  ReservaNegada: 'reserva_negada',
  ContinuarAnaliseFuro: 'continuar',
  FuroEncerramento: 'furo_encerramento',
  FuroContemplacao: 'furo_contemplacao',
  Diluicao: 'diluicao'
}
export const OpcoesFuroDesc = {
  [OpcoesFuro.ReservaNegada]: 'Reserva Negada',
  [OpcoesFuro.ContinuarAnaliseFuro]: 'Continuar Analise do Furo',
  [OpcoesFuro.FuroEncerramento]: 'Furo no Encerramento',
  [OpcoesFuro.FuroContemplacao]: 'Furo na Contemplação',
  [OpcoesFuro.Diluicao]: 'Diluição'
}

export const TipoEndereco = {
  Comercial: 'comercial',
  Residencial: 'residencial'
}

export const TipoPessoa = {
  Fisica: 'fisica',
  Juridica: 'juridica'
}

export const TipoConta = {
  Corrente: 'corrente',
  Poupanca: 'poupanca'
}

export const FormasPagamento = {
  Cartao: 'cartao',
  Boleto: 'boleto',
  Link: 'link'
}

export const Nacionalidades = {
  Brasileira: 'BRASILEIRA',
  Estrangeira: 'ESTRANGEIRA'
}

export const TipoTelefone = {
  telefone_celular: 3,
  telefone_residencial: 6,
  telefone_fax: 4,
  telefone_comercial: 2,
  telefone_correspondencia: 2,
  telefone_outro: 1
}

export const EstadoCivil = {
  casado: 1,
  desquitado: 2,
  separado_judicialmente: 3,
  outro: 4,
  divorciado: 5,
  solteiro: 6,
  concubinato: 7,
  uniao_estavel: 8,
  viuvo: 9
}

export const OrigemPedido = {
  android: 'android',
  web: 'web',
  ios: 'ios',
  sincronizacao: 'sincronizacao'
}

export const CargaInformacoesStatus = {
  Executando: 'executando',
  Pendente: 'pendente',
  Finalizado: 'finalizado'
}

export const Meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']

export const OrigemReserva = {
  /** @deprecated Descontinuado desde a 2.02.920. A partir dessa versão, dentro do sistema web podem existir mais que uma origem, então elas devem ser diferenciadas */
  Web: 'web',
  App: 'app',
  NewCon: 'newcon',
  PoliticaVendas: 'politica_vendas',
  FluxoVenda: 'fluxo_venda',
  TelaReservas: 'reservas'
}

export const KB = 1000

export const MB = KB * 1000

export const AcoesRastreio = {
  visualizarDocumento: 'Visualizar Documentos',
  compartilharDocumentos: 'Compartilhar documentos',
  reenviarContratoEmail: 'Reenviar contrato via e-mail',
  reenviarContratoWhatsapp: 'Reenviar contrato via whats',
  enviarContrato: 'Enviar contrato docusign',
  liberarAssinatura: 'Liberar assinatura'
}

export const TiposGrupoIndividualText = {
  GrupoPontual: 'Grupo Pontual',
  GrupoConvencional: 'Grupo Convencional',
  GrupoPraJa: 'Grupo Pra Já'
}
export const TiposGrupo = {
  GrupoPontual: 'Grupos Pontuais',
  GrupoConvencional: 'Grupos Convencionais',
  GrupoPraJa: 'Grupos Pra Já'
}

export const erro_timeout_newcon = 'Error Fetching http headers'

export const ErrosCadastroExterno = {
  'ERRO_SESSAO_INVALIDADA': 'Sessão do usuário invalidada, favor acessar novamente.',
  'ERRO_PROCESSANDO_USUARIO': 'Processando cadastro do usuário. Aguarde até 24 horas para nova tentativa de login.',
  'ERRO_AUTO_CADASTRO': 'Ocorreu um erro ao realizar o Auto Cadastro, tente novamente mais tarde ou entre em contato com a administradora.'
}

export const DadosPadraoFormularioCadastroExterno = {
  'dadosBase': {
    'empresa': '0001',
    'categoriaPessoa': 'PF',
    'cpf': null,
    'rg': null,
    'dataEmissaoRg': null,
    'estadoEmissor': null
  },
  'dadosPessoa': {
    'nomeCompleto': null,
    'sexo': null,
    'telefone': null,
    'email': null,
    'nascimento': null,
    'cidadeNascimento': null,
    'uf': null,
    'nacionalidade': 'BR'
  },
  'dadosEndereco': {
    'cidade': 'UBERLÂNDIA',
    'bairro': 'NSA. SRA APARAECIDA',
    'cep': '38400694',
    'rua': 'AV CESÁRIO ALVIM',
    'numero': '2209',
    'complemento': '-',
    'estado': 'MG'
  }
}

export const BankTypes = {
  debito_automatico: 'debito_automatico',
  devolucao: 'devolucao'
}

export const origensAcesso = {
  login_e_senha: 'Tela de login',
  link_externo: 'Área do Parceiro',
  sso: 'ED',
  api_externa: 'API Externa',
  login_painel: 'Painel Adm',
  undefined: 'Não Definido',
  buscador: 'Buscador de Grupos - ED'
}

export const NavigationErrorTypes = {
  REDIRECT: 'redirect',
  POPUP: 'pop-up',
  CONSOLE: 'console'
}

export const NavigationErrorCategory = {
  PERMISSION_DENIED: 'permissão negada',
  HIDDEN_MENU: 'menu não habilitado',
  PRIVATE_ROUTE: 'rota protegida por login'
}

export const ErrorCategory = {
  RECEBIMENTO_PROPOSTA: 'prcRegistroRecebimentoPropostaUpd',
  GERAR_TRANSACAO_CARTAO: 'prcGerarTransacaoCartaoPGC'
}

export const FormasPagamentoDesc = {
  [FormasPagamento.Cartao]: 'Cartão',
  [FormasPagamento.Boleto]: 'Boleto',
  [FormasPagamento.Link]: 'Link'
}

export const NivelPermissoesPerfil = {
  Analista: { id_banco: 1, nome_banco: 'Analista' },
  Gerente: { id_banco: 2, nome_banco: 'Gerente' },
  Suporte: { id_banco: 3, nome_banco: 'Suporte' }
}

export const PerfisAdmin = {
  Sem_Acesso: { id_banco: 1, nome_banco: 'Sem Acesso' },
  Administraor: { id_banco: 2, nome_banco: 'Administrador' },
  Super_Admin: { id_banco: 3, nome_banco: 'Super Admin' },
  Credito: { id_banco: 4, nome_banco: 'Crédito' }
}

export const SituationAnalysisCredit = {
  APROVADO: 'Aprovado',
  ANALISAR: 'Analisar',
  REPROVADO: 'Reprovado',
  PENDENTE: 'Pendente',
  PENDENCIA_CADASTRAL: 'Pendência Cadastral'
}

export const Grupo = {
  Pontual: 'Pontual',
  Convencional: 'Convencional',
  PraJa: 'Pra Já'
}

export const TiposDePlano = ['Linear', 'Degrau', 'Outro']

export const CreditasAvaliationStatus = {
  PENDENTE: 'pendente',
  CONCLUIDO: 'concluido',
  ANALISE: 'analisando'
}

export const ApprovalOrigins = {
  painel: 'painel',
  automacao: 'automacao'
}

export const ApprovalOriginsDesc = {
  [ApprovalOrigins.painel]: 'Painel',
  [ApprovalOrigins.automacao]: 'Automação'
}

export const SituationAnalysisCreditFormat = {
  APROVADA: 'Aprovada',
  REPROVADA: 'Reprovada'
}

export const LoginComum = 'normal'
export const LoginCpfCnpj = 'cpfCnpj'

export const CommercialHierarchyTypes = {
  RC: { text: 'Regional Comercial', code: 1 },
  GN: { text: 'Gerente de Negócio', code: 2 },
  COMISSIONADO: { text: 'Comissionado', code: 3 },
  ASSISTENTE: { text: 'Assistente', code: 4 },
  Todos: { text: 'Todos', code: 0 }
}

export const Flavors = {
  ED: 'escritorio_digital',
  Tribanco: 'tribanco'
}
export const FlavorsSemBarraSuperior = [Flavors.Tribanco]

export const ValuesFunctionalities = {
  DESABILITAR: 0,
  HABILITAR: 1,
  HABILITAR_PARA: 2
}

export const FonteMotivoCredito = {
  PAINEL: 1,
  MOTOR_CREDITO: 2,
  RESPOSTA_ANALISE_MANUAL: 3
}

export const confirmationMessage = `Alterar dados da Hierarquia Comercial irá encerrar o fluxo de venda em questão e você será retornado para a listagem de vendas. Deseja prosseguir?`

export const TIPOS_PROVEDOR_CONTRATO = {
  docusign: 'docusign',
  ac: 'assinatura_consorcio',
  sem_provedor: 'sem_provedor'
}

export const TIPOS_PROVEDOR_CONTRATO_DESC = {
  [TIPOS_PROVEDOR_CONTRATO.docusign]: 'Docusign',
  [TIPOS_PROVEDOR_CONTRATO.ac]: 'Assinatura Consórcio',
  [TIPOS_PROVEDOR_CONTRATO.sem_provedor]: '-'
}
export const VALOR_FILTRO_TIPO_CONTRATO = {
  [TIPOS_PROVEDOR_CONTRATO.docusign]: { value: 0, label: TIPOS_PROVEDOR_CONTRATO_DESC.docusign },
  [TIPOS_PROVEDOR_CONTRATO.ac]: { value: 1, label: TIPOS_PROVEDOR_CONTRATO_DESC.assinatura_consorcio },
  [TIPOS_PROVEDOR_CONTRATO.sem_provedor]: { value: -1, label: 'Não Gerado' }
}

export const ErrorsThatCannotBeShow = [
  'RequestManager.cancelAllRequests',
  'Network Error',
  'Request failed with status code 500',
  'Request failed with status code 401',
  'TypeError: Cannot read properties of undefined (reading \'seguro\')'
]

export const TiposGrupoIniciais = {
  GrupoPontual: 'P',
  GrupoConvencional: 'C',
  GrupoPraJa: 'PJ'
}

export const FiltroTiposGrupo = [
  { value: TiposGrupoIniciais.GrupoConvencional, label: 'Grupos Convencionais' },
  { value: TiposGrupoIniciais.GrupoPraJa, label: 'Grupos Pra Já' },
  { value: TiposGrupoIniciais.GrupoPontual, label: 'Grupos Pontuais' }
]

export const TiposGrupoFiltro = [
  { value: Grupo.PraJa, label: 'Pra Já' },
  { value: Grupo.Convencional, label: 'Convencional' },
  { value: Grupo.Pontual, label: 'Pontual' }
]

export const TiposDeIndice = [
  { value: 'IPCA', label: 'IPCA' },
  { value: 'FIPE', label: 'FIPE' },
  { value: 'INCC', label: 'INCC' },
  { value: 'INPC', label: 'INPC' }
]

export const FiltroMotores = ['Crivo', 'Vadu']

export const StatusUsuario = {
  Liberado: { value: 0, label: 'Liberado' },
  Bloqueado: { value: 1, label: 'Bloqueado' }
}

export const StatusPerfilAdmin = {
  ATIVO: { text: 'Ativo', value: 1 },
  INATIVO: { text: 'Inativo', value: 0 }
}

export const permissaoPerfilAdmin = {
  SIM: { text: 'Sim', value: 1 },
  NAO: { text: 'Não', value: 0 }
}

export const OpcoesStatusUsuario = [
  StatusUsuario.Liberado,
  StatusUsuario.Bloqueado
]

export const ListaAgrupamentosDeStatusPagamento = {
  Falha: 'Falha no pagamento',
  Realizado: 'Pagamento realizado',
  Pendente: 'Aguardando pagamento',
  EmEspera: 'Em Espera'
}

export const ListaAgrupamentosDeStatusPagamentoPrioridade = {
  [ListaAgrupamentosDeStatusPagamento.EmEspera]: 1,
  [ListaAgrupamentosDeStatusPagamento.Falha]: 2,
  [ListaAgrupamentosDeStatusPagamento.Pendente]: 3,
  [ListaAgrupamentosDeStatusPagamento.Realizado]: 4
}

export const agrupamentoStatusPagamentoCores = {
  [ListaAgrupamentosDeStatusPagamento.Realizado]: '#1A984C',
  [ListaAgrupamentosDeStatusPagamento.Pendente]: '#1E90FF',
  [ListaAgrupamentosDeStatusPagamento.Falha]: '#DC222B',
  [ListaAgrupamentosDeStatusPagamento.EmEspera]: '#B8B8B8'
}

export const SituacaoAnalise = {
  AprovadoCrivo: 100,
  AprovadoCredita: 111,
  AprovadoPainel: 149,
  ReprovadoCrivo: 200,
  ReprovadoCredita: 222,
  ReprovadoPainel: 299
}

export const TiposAnaliseCredito = [
  { value: SituacaoAnalise.AprovadoCrivo, label: 'Aprovado - Crivo' },
  { value: SituacaoAnalise.AprovadoCredita, label: 'Aprovado - Credita' },
  { value: SituacaoAnalise.AprovadoPainel, label: 'Aprovado - Painel' },
  { value: SituacaoAnalise.ReprovadoCrivo, label: 'Reprovado - Crivo' },
  { value: SituacaoAnalise.ReprovadoCredita, label: 'Reprovado - Credita' },
  { value: SituacaoAnalise.ReprovadoPainel, label: 'Reprovado - Painel' }
]

export const StatusUser = [
  { text: 'Ativo', value: 1 },
  { text: 'Inativo', value: 0 }
]
